import { HttpClient } from '@angular/common/http';
import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Entity } from '@app/app.model';
import { AppService } from '@app/app.service';
import { ActionsService } from '@app/_shared/actions/actions.service';
import { ErrorsService } from '@app/_shared/errors/errors.service';
import { DxDataGridComponent } from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductGroup, ProductGroupInterface } from './product-group.model';
import { ProductGroupService } from './product-group.service';
import { IsUndefinedOrNull, dxDataGridHeightAdjustment } from '@app/common_helper';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'facnm-product-group',
  templateUrl: './product-group.component.html',
  styleUrls: ['./product-group.component.scss'],
  providers: [
    {
      provide: ProductGroupInterface,
      useFactory: (httpClient: HttpClient, errors$: ErrorsService): any => {
        return new ProductGroupService(httpClient, errors$);
      },
      deps: [HttpClient, ErrorsService]
    }
  ]
})
export class ProductGroupComponent implements OnInit {
  constructor(
    private productGroup$: ProductGroupInterface,
    private actions$: ActionsService,
    private errors$: ErrorsService,
    private app$: AppService,
    private ngxSmartModalService: NgxSmartModalService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  @ViewChild('dataGrid', { static: true }) dataGrid: DxDataGridComponent;
  @ViewChild('entityForm') entityForm: NgForm;

  private unsubscribe$ = new Subject<void>();
  gridData: ArrayStore;
  isAddForm = 0;
  entityName = 'Product Group';
  entityNameAdd = 'New Product Group';
  entityData: Entity<ProductGroup>;
  productList: any;
  newEntityData: ProductGroup;
  newEntity: any;
  PCollapse = false;
  VCollapse = false;
  collapseColor = 'green';
  RelatedProducts = [];
  selectedProductGroupID = 0;

  ngOnInit(): void {
    this.actions();
    this.getList();
    this.app$.setScreenTitle(this.entityName);
  }

  actions() {
    this.productGroup$.ListRetrieved.subscribe(data => {
      if (data) {
        this.gridData = new ArrayStore({
          data: data,
          key: ["Id"]
        });
      }
    });

    this.actions$.EntityAdding.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.addNewEntity());
    this.actions$.EntityCreating.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.create(false));
    this.actions$.EntitySaving.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.create(true));
    this.actions$.EntityDeleteConfirmed.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.deleteConfirm());
    this.actions$.EntityResetting.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.reset());
    this.actions$.EntityCanceling.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.cancel());
    this.errors$.ServerErrorsReceived.pipe(takeUntil(this.unsubscribe$)).subscribe((errors) => {
      if (errors) {
        let entityForm = document.getElementById('entity-form');
        if (entityForm) {
          entityForm.scrollTop = 0;
        }
      }
    });
  }

  getList() {
    this.productGroup$.getList().subscribe(listWithCreated => {
      this.productGroup$.notifyRetrieved(listWithCreated);
      this.app$.notifyScreenReady();
    }, (errorGetList) => this.errors$.handleServerErrors(errorGetList));
  }

  private handleFormSubmit() {
    this.entityForm.form.markAsPristine();
    this.entityForm.form.markAsUntouched();
    this.entityForm.form.updateValueAndValidity();
  }

  create(isSave: boolean) {
    this.handleFormSubmit();
    this.entityForm.onSubmit(undefined);
    if (this.entityForm.form.invalid) {
      setTimeout(() => { this.app$.notifyScreenReady(); })
      return;
    }
    this.productGroup$.create(this.entityData).subscribe(
      (okCreate) => {
        this.app$.setScreenTitle(this.entityName);
        isSave ? this.actions$.notifySaved() : this.actions$.notifyCreated();
        this.getEntity(this.entityData.value.Id);
      },
      (errorCreate) => {
        this.errors$.handleServerErrors(errorCreate);
      }
    );
  }
  saveRelatedProducts() {
    this.app$.notifyScreenBusy();
    this.ngxSmartModalService.close('modal');
    this.productGroup$.create(this.entityData).subscribe(
      (okCreate) => {
        this.app$.setScreenTitle(this.entityName);
        this.actions$.notifySaved();
        this.app$.notifyScreenReady();
        this.selectEntity({ Id: this.entityData.value.Id });
      },
      (errorCreate) => {
        this.errors$.handleServerErrors(errorCreate);
      }
    );
  }

  getEntity(id) {
    this.productGroup$.getEntity(id).subscribe((res: any) => {
      this.entityData = new Entity();
      this.entityData.key = id;
      this.entityData.value = cloneDeep(res);
      if (this.entityData.value.RelatedProducts.length > 0) {
        this.RelatedProducts = this.entityData.value.RelatedProducts;
        this.ngxSmartModalService.open('modal');
        this.app$.notifyScreenReady();
      } else {
        this.app$.notifyScreenReady();
        this.getList();
        this.refreshGrid();
        this.deSelectEntity();

      }
    }, (errorGetList) => this.errors$.handleServerErrors(errorGetList));
  }

  private deleteConfirm() {
    this.productGroup$.delete(this.entityData.value.Id).subscribe(
      (okDelete) => {
        this.cancel();
        this.getList();
        this.actions$.notifyDeleted();
        this.app$.notifyScreenReady();
      },
      (errorDelete) => {
        this.errors$.handleServerErrors(errorDelete);
      }
    );
  }

  private addNewEntity() {
    this.app$.setScreenTitle('New ' + this.entityName);
    this.productGroup$.getEntity(0).subscribe((res: any) => {
      this.app$.notifyScreenReady();
      this.entityData = new Entity();
      this.entityData.value = cloneDeep(res);
      this.entityData.created = true;
      this.isAddForm = 1;
      this.collapseColor = 'yellow';
      this.changeDetectorRef.detectChanges();
    }, (errorGetList) => this.errors$.handleServerErrors(errorGetList));
  }

  onContentReadyGroup(e) {
    this.dataGrid.noDataText = this.dataGrid.instance.totalCount() ? '' : "No Product Groups Found";
  }

  private selectEntity(key: any) {
    this.app$.notifyScreenBusy();
    this.productGroup$.getEntity(key.Id).subscribe((res: any) => {
      this.app$.notifyScreenReady();
      this.entityData = new Entity();
      this.entityData.key = key;
      this.entityData.value = cloneDeep(res);
      this.isAddForm = 0;
      this.collapseColor = 'green';
      this.changeDetectorRef.detectChanges();
      if (this.entityData.value.RelatedProducts.length > 0) {
        this.RelatedProducts = this.entityData.value.RelatedProducts;
        this.ngxSmartModalService.open('modal');
      }
    }, (errorGetList) => this.errors$.handleServerErrors(errorGetList));
  }

  refreshGrid() {
    this.dataGrid.instance.refresh();
  }

  private deSelectEntity() {
    this.dataGrid.instance.deselectRows(this.entityData.key);
    this.entityData.key = undefined;
  }

  private reset() {
    this.entityData.restore();
    if (IsUndefinedOrNull(this.entityData.value.AssignedProducts)) {
      this.entityData.value.AssignedProducts = [];
    }
    if (IsUndefinedOrNull(this.entityData.value.AssignedDataAreas)) {
      this.entityData.value.AssignedDataAreas = [];
    }
    if (IsUndefinedOrNull(this.entityData.value.UnassignedProducts)) {
      this.entityData.value.UnassignedProducts = [];
    }
    if (IsUndefinedOrNull(this.entityData.value.UnassignedDataAreas)) {
      this.entityData.value.UnassignedDataAreas = [];
    }
    this.entityData.restore();
  }

  private cancel() {
    this.app$.setScreenTitle(this.entityName);
    this.deSelectEntity();
  }

  onInitialized(e: any) {
    this.resizeScreenContent();
  }
  onRowClick($clikedRow: { key: any; }) {
    this.app$.setScreenTitle(this.entityName + 's');
    if (!this.entityData) {
      this.entityData = new Entity();
      this.entityData.key = undefined;
    }
    if (JSON.stringify(this.entityData.key) === JSON.stringify($clikedRow.key)) {
      this.deSelectEntity();
    }
    else {
      this.selectEntity($clikedRow.key);
    }
  }

  collapseClass(pannel) {
    return {
      'collapsible-header-icon-green-up': !pannel && !this.isAddForm,
      'collapsible-header-icon-green-down': pannel && !this.isAddForm,
      'collapsible-header-icon-yellow-up': !pannel && this.isAddForm,
      'collapsible-header-icon-yellow-down': pannel && this.isAddForm,
    }
  }

  hasError(control) {
    return this.entityForm?.submitted && this.entityForm.form.get(control)?.errors;
  }

  checkError(control, type) {
    return this.entityForm.form.get(control).errors[type];
  }

  onResize(e: any): void {
    this.resizeScreenContent();
  }

  formHeight: string;
  @ViewChild('screen', { static: true }) screenElement: ElementRef;
  private resizeScreenContent() {
    let h = this.screenElement.nativeElement.clientHeight;
    this.formHeight = h - 80 + 'px';
    this.dataGrid.instance.option('height', h - dxDataGridHeightAdjustment);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}


